import { StarRatingProps } from '@/types/contact'
import { Star } from 'lucide-react'

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  size = 24
}) => {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map(star => (
        <Star
          key={star}
          size={size}
          className={`cursor-pointer transition-colors ${
            star <= value
              ? 'fill-shire-sun text-shire-sun'
              : 'text-shire-stone hover:text-shire-sun'
          }`}
          onClick={() => onChange(star)}
        />
      ))}
    </div>
  )
}

export { StarRating }
